import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import CropImageFieldNoCrop from '@components/common/form/CropImageField/CropImageFieldNoCrop';
import { AppConstants } from '@constants';
import apiConfig from '@constants/apiConfig';
import useBasicForm from '@hooks/useBasicForm';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, TextField } from '@itz/react-cms-element';
import { getBase64 } from '@utils';
import { Card, Col, Form, Row } from 'antd';

const messages = defineMessages({
    image: 'Image',
    groupFoodName: 'Group Food Name',
});

const InwenForm = (props) => {
    const { formId, dataDetail, onSubmit, setIsChangedFormValues, actions } = props;
    const [ imageUrl, setImageUrl ] = useState(null);
    const [ isSubmitted, setIsSubmitted ] = useState(false);
    const translate = useTranslate();
    const { execute: executeUpFile } = useFetch(apiConfig.file.upload);
    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const uploadFile = (file, onSuccess, onError) => {
        getBase64(file, (base64Image) => {
            if (base64Image.startsWith('data:image')) {
                setImageUrl(base64Image);
            } else {
                setImageUrl(`data:image/png;base64,${base64Image}`);
            }
            onSuccess();
        });
    };

    useEffect(() => {
        form.setFieldsValue({
            ...dataDetail,
        });
        setImageUrl(
            dataDetail.inwenMediaLibraryData ? `data:image/png;base64,${dataDetail.inwenMediaLibraryData}` : '',
        );
    }, [ dataDetail ]);

    const handleFinish = (values) => {
        setIsSubmitted(true);
        mixinFuncs.handleSubmit({
            ...values,
            inwenMediaLibraryData: imageUrl?.split(',')[1],
        });
    };

    const handleFailed = ({ errorFields }) => {
        setIsSubmitted(true);
    };

    return (
        <BaseForm
            id={formId}
            onFinish={handleFinish}
            onFinishFailed={handleFailed}
            form={form}
            onValuesChange={onValuesChange}
        >
            <Card className="card-form" bordered={false}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                                prevValues.inwenMediaLibraryData !== currentValues.inwenMediaLibraryData
                            }
                            noStyle
                        >
                            {({ getFieldError }) => {
                                const hasError = getFieldError('inwenMediaLibraryData').length > 0;
                                return (
                                    <CropImageFieldNoCrop
                                        label={<FormattedMessage defaultMessage="Image" />}
                                        name="inwenMediaLibraryData"
                                        imageUrl={imageUrl}
                                        aspect={1 / 1}
                                        required
                                        uploadFile={uploadFile}
                                        formItemProps={{
                                            className: hasError ? 'error-field' : '',
                                        }}
                                    />
                                );
                            }}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            label={<FormattedMessage defaultMessage="Name" />}
                            name="inwenMediaLibraryName"
                            required
                        />
                    </Col>
                </Row>
                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default InwenForm;